import { OctHeaderWrapper } from '@oceantech/oceantech-ui'
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../../app/modules/auth'
import { reInitMenu } from '../helpers'
import {
  ActivityDrawer,
  DrawerMessenger,
  InviteUsers,
  ThemeModeProvider,
  UpgradePlan,
} from '../partials'
import { Content } from './components/content'
import { ScrollTop } from './components/scroll-top'
import { ToolbarWrapper } from './components/toolbar'
import { PageDataProvider } from './core'
import { hasAuthority } from '../../app/modules/utils/Permission'
import { ROLE } from '../../app/modules/utils/Constant'
import { HeaderWrapper } from './components/header'


const MasterLayout = () => {
  const location = useLocation();
  const { logout } = useAuth();

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  const menus = [
    ...(
      hasAuthority(ROLE.PHONG_NCKH) ? [
        {
          id: 1,
          name: "Mở đợt đăng ký",
          description: "Mở đợt đăng ký",
          path: "/USER/",
          uri: "quan-ly-de-tai/mo-dot-dang-ky",
          order: 1,
          isMain: false,
          disabled: false,
        },
      ] : []
    ),
    {
      id: 2,
      name: "Đăng ký đề tài",
      description: "Đăng ký đề tài",
      path: "/USER/",
      uri: "/dang-ky-de-tai",
      order: 1,
      isMain: false,
      disabled: false,
    },
    {
      id: 3,
      name: "Đề tài của tôi",
      description: "Đề tài của tôi",
      path: "/USER/",
      uri: "/de-tai-cua-toi",
      order: 1,
      isMain: false,
      disabled: false,
    }, 
    {
      id: 4,
      name: "Danh sách đề tài",
      description: "Danh sách đề tài",
      path: "/USER/",
      uri: "quan-ly-de-tai/de-tai",
      order: 1,
      isMain: false,
      disabled: false,
    },
    ...(
      hasAuthority(ROLE.PHONG_NCKH) ? [
        {
          id: 5,
          name: "Hội đồng khoa học",
          description: "Hội đồng khoa học",
          path: "/USER/",
          uri: "/quan-ly-hoi-dong/khoa-hoc",
          order: 1,
          isMain: false,
          disabled: false,
        },
        {
          id: 6,
          name: "Hội đồng nghiệm thu",
          description: "Hội đồng nghiệm thu",
          path: "/USER/",
          uri: "/quan-ly-hoi-dong/nghiem-thu",
          order: 1,
          isMain: false,
          disabled: false,
        },
        {
          id: 7,
          name: "Hội đồng NCKH bệnh viện",
          description: "Hội đồng NCKH bệnh viện",
          path: "/USER/",
          uri: "/quan-ly-hoi-dong/benh-vien",
          order: 1,
          isMain: false,
          disabled: false,
        },
      ] : []
    ),
    ...(
      (hasAuthority(ROLE.PHONG_NCKH) || hasAuthority(ROLE.GIAM_DOC)) ? [
        {
          id: 8,
          name: "Quyết định giao thực hiện",
          description: "Quyết định giao thực hiện",
          path: "/USER/",
          uri: "quyet-dinh-giao-thuc-hien",
          order: 1,
          isMain: false,
          disabled: false,
        },
        {
          id: 9,
          name: "Quyết định công nhận",
          description: "Quyết định công nhận",
          path: "/USER/",
          uri: "quyet-dinh-cong-nhan",
          order: 1,
          isMain: false,
          disabled: false,
        },
      ] : []
    ),
  ]

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {
              true ? (
                <OctHeaderWrapper
                  onLogout={logout}
                  menuOptions={menus}
                />
              ) : (
                <HeaderWrapper />
              )
            }
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid p-0'>
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                {/* <FooterWrapper /> */}
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        {/* <RightToolbar /> */}
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }

